/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ContactMethodError.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ContactMethodError } from "./ContactMethodError";

export abstract class ContactMethodErrorModel {
    id: number;
    code: string;
    contactMethodErrorableId: number;
    contactMethodErrorableType: string;
    createdAt: Dayjs;
    message: string;
    updatedAt: Dayjs;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        code: string,
        contactMethodErrorableId: number,
        contactMethodErrorableType: string,
        createdAt: Dayjs,
        message: string,
        updatedAt: Dayjs
    ) {
        this.id = id;
        this.code = code;
        this.contactMethodErrorableId = contactMethodErrorableId;
        this.contactMethodErrorableType = contactMethodErrorableType;
        this.createdAt = createdAt;
        this.message = message;
        this.updatedAt = updatedAt;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): ContactMethodError {
        const newObject = new ContactMethodError(
            json["id"],
            json["code"],
            json["contact_method_errorable_id"],
            json["contact_method_errorable_type"],
            dayjs(json["created_at"]).tz(timezone),
            json["message"],
            dayjs(json["updated_at"]).tz(timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            code: this.code,
            contact_method_errorable_id: this.contactMethodErrorableId,
            contact_method_errorable_type: this.contactMethodErrorableType,
            created_at: this.createdAt,
            message: this.message,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ContactMethodError {
        const clone = Object.create(this) as ContactMethodError;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
